angular.module('ikeweb.spike.step').factory('stepService', ['$stateParams', '$location', 'STEPS',
    function($stateParams, $location, STEPS) {

        function getLastPartOfPath() {
            return $location.path().split('/').pop();
        }

        function isAStep(value) {
            return STEPS.values.filter(function(step) {
                return step === value;
            }).length > 0;
        }

        function getCurrentStep() {
            return isAStep(getLastPartOfPath()) ?
                getLastPartOfPath() :
                undefined;
        }

        function isTransitionForbidden(step) {
            return getCurrentStep() === STEPS.ALIGN && step === STEPS.REPORT;
        }

        function isCurrentStep(step) {
            return !!(step && getCurrentStep() === step);
        }

        function changeStep(step) {
            if (isTransitionForbidden(step)) {
                return;
            }

            $location.path('/photoMeasure/' + $stateParams.spikeid + '/' + step);
        }

        return {
            isCurrentStep: isCurrentStep,
            changeStep: changeStep,
            getCurrentStep: getCurrentStep,
            isTransitionForbidden: isTransitionForbidden
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/step/step.service.js
// module id = 596
// module chunks = 0